import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { FAQSection } from './components/FAQSection';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-[#FDF8F0] font-sans text-[#2D2D2D] selection:bg-[#C5A55A] selection:text-[#0F1D33]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <AudienceSection data-id="element-4" />
      <HowItWorksSection data-id="element-5" />
      <FAQSection data-id="element-6" />
      <PricingCTA data-id="element-7" />
      <Footer data-id="element-8" />
    </main>;
}